import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["theme", "variant", "children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'emotion-theming';
import { themeGet } from 'styled-system';
import { Text, Flex, Box, Icon } from "../../..";
var ModalHeader = withTheme(function (_ref) {
  var theme = _ref.theme,
      variant = _ref.variant,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  var _themeGet$props = _objectSpread(_objectSpread({}, themeGet("alertStyles.".concat(variant))({
    theme: theme
  })), props),
      icon = _themeGet$props.icon,
      bg = _themeGet$props.bg;

  return /*#__PURE__*/React.createElement(Box, _extends({}, props, {
    bg: bg
  }), /*#__PURE__*/React.createElement(Flex, {
    px: 11,
    py: 9,
    justifyContent: "center",
    alignItems: "center"
  }, icon && /*#__PURE__*/React.createElement(Box, {
    pr: 3
  }, /*#__PURE__*/React.createElement(Icon, icon)), /*#__PURE__*/React.createElement(Text, {
    mb: 0,
    fontSize: "xl",
    textAlign: "left",
    fontWeight: "bold"
  }, children)));
});
ModalHeader.displayName = 'Modal.header';
ModalHeader.defaultProps = {
  variant: 'default'
};
ModalHeader.propTypes = _objectSpread({
  children: PropTypes.node.isRequired,
  icon: PropTypes.shape(Icon.propTypes),
  variant: PropTypes.string
}, Box.propTypes);
export default ModalHeader;